import { useState } from 'react';
import type { ClientVacationGroup } from '../../../models/vacationClientView.types';
import { ClientPanelHeader } from './ClientPanelHeader';
import { CollapsibleRegion } from './CollapsibleRegion';
import { ResponsibleSection } from './ProjectSection';

interface ClientPanelCardProps {
    group: ClientVacationGroup;
    onOpenRequest?: (collaboratorId: string) => void;
    initiallyExpanded?: boolean;
}

export function ClientPanelCard({ group, onOpenRequest, initiallyExpanded = false }: ClientPanelCardProps) {
    const [isOpen, setIsOpen] = useState(initiallyExpanded);
    const bodyId = `client-panel-body-${group.clientId}`;
    const responsibles = group.responsibles || [];

    return (
        <div className="rounded-xl border border-raro-gray-200 bg-white shadow-raro overflow-hidden">
            <ClientPanelHeader
                group={group}
                isOpen={isOpen}
                controlsId={bodyId}
                onToggle={() => setIsOpen((prev) => !prev)}
            />
            <CollapsibleRegion id={bodyId} isOpen={isOpen}>
                {responsibles.length > 0 ? (
                    <div className="space-y-4 px-4 py-4">
                        {responsibles.map((responsible, index) => (
                            <ResponsibleSection
                                key={responsible.responsibleKey}
                                responsible={responsible}
                                clientId={group.clientId}
                                clientName={group.clientName}
                                onOpenRequest={onOpenRequest}
                                initiallyExpanded={initiallyExpanded && index === 0}
                            />
                        ))}
                    </div>
                ) : null}
            </CollapsibleRegion>
        </div>
    );
}

export default ClientPanelCard;
